import util from "@/libs/util.js";
import { AccountLogin } from "@/api/sys/login";
import {Logout} from "@/api/sys/index";

export default {
  namespaced: true,
  state: {
    loginContentShow: false,
  },
  actions: {
    /**
     * @description 登录
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param user {String} 用户账号
     * @param {Object} param pwd {String} 密码
     * @param {Object} param route {Object} 登录成功后定向的路由对象
     */
    login(
      { state, dispatch },
      {
        vm,
        user,
        pwd,
        route = {
          name: "index",
        },
      }
    ) {
      pwd= rsa.en1(pwd);
      // 开始请求登录接口
      AccountLogin({
        user,
        pwd,
        NECaptchaValidate:document.getElementsByName("NECaptchaValidate")[0].value
      })
        .then(async (res) => {
          // 设置 cookie 一定要存 uuid 和 token 两个 cookie
          // 整个系统依赖这两个数据进行校验和存储
          // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
          // token 代表用户当前登录状态 建议在网络请求中携带 token
          // 如有必要 token 需要定时更新，默认保存一天
          console.log(res);
          util.cookies.set("uuid", res.user);
          util.cookies.set("token", res.token);
          util.cookies.set("userInfo", res.userInfo);
          // 设置 vuex 用户信息
          await dispatch(
            "d2admin/user/set",
            {
              name: res.userInfo.Name,
            },
            {
              root: true,
            }
          );
          // 用户登录后从持久化数据加载一系列的设置
          await dispatch("load");
          if (res.isFirstLogin) {
            state.loginContentShow = true;
            return false;
          } else {
            state.loginContentShow = false;
          }
          // 更新路由 尝试去获取 cookie 里保存的需要重定向的页面完整地址
          const path = util.cookies.get("redirect");
          // 根据是否存有重定向页面判断如何重定向
          vm.$router.replace(
            path
              ? {
                  path,
                }
              : route
          );
          // 删除 cookie 中保存的重定向页面
          util.cookies.remove("redirect");
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    // 第一次登陆
    surelogin(
      { state },
      {
        vm,
        route = {
          name: "index",
        },
      }
    ) {
      // 更新路由 尝试去获取 cookie 里保存的需要重定向的页面完整地址
      const path = util.cookies.get("redirect");
      // 根据是否存有重定向页面判断如何重定向
      vm.$router.replace(
        path
          ? {
              path,
            }
          : route
      );
      // 删除 cookie 中保存的重定向页面
      util.cookies.remove("redirect");
      state.loginContentShow = false;
    },
    // 取消登录
    cancellogin({ state }, { vm }) {
      /**
       * @description 注销
       */
      // 删除cookie
      util.cookies.remove("token");
      util.cookies.remove("uuid");
      // 跳转路由
      vm.$router.push({
        name: "login",
      });
      state.loginContentShow = false;
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param confirm {Boolean} 是否需要确认
     */
    logout({ commit, dispatch }, { vm, confirm = false }) {
      /**
       * @description 注销
       */
      function logout() {
        Logout({}).then((data) => {
          
        }).finally(res => {
          // 不管状态如何，都一定会执行此函数
          // 删除cookie
          util.cookies.remove("token");
          util.cookies.remove("uuid");
          // 跳转路由
          vm.$router.push({
            name: 'login'
          })
          // window.location.href =
          //   "https://admin.srpltradeunion.com/WebPages/UIDSLogin.aspx?state=3"; 
          this.$router.push('/login');
        })

      }
      // 判断是否需要确认
      if (confirm) {
        commit("d2admin/gray/set", true, {
          root: true,
        });
        vm.$confirm("注销当前用户吗? ", "确认操作", {
          confirmButtonText: "确定注销",
          cancelButtonText: "放弃",
          type: "warning",
        })
          .then(() => {
            commit("d2admin/gray/set", false, {
              root: true,
            });
            // 清空用户数据
            dispatch("d2admin/userInfo/set", {}, { root: true });
            logout();
            //注销后重置应用，目前没有找到更好的方法
            setTimeout(() => {
              location.reload();
            }, 1000);
          })
          .catch(() => {
            commit("d2admin/gray/set", false, {
              root: true,
            });
            vm.$message("放弃注销用户");
          });
      } else {
        logout();
        setTimeout(() => {
          location.reload();
        }, 1000);
      }
    },
    gotoUids() {
      util.cookies.remove("token");
      util.cookies.remove("uuid");
      window.location.href =
        "https://admin.srpltradeunion.com/WebPages/UIDSLogin.aspx?state=3";
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} state vuex state
     */
    load({ commit, dispatch }) {
      return new Promise(async (resolve) => {
        // DB -> store 加载用户名
        await dispatch("d2admin/user/load", null, {
          root: true,
        });
        // DB -> store 加载绑定列表
        await dispatch("d2admin/list/load", null, {
          root: true,
        });
        //
        await dispatch("d2admin/router/load", null, {
          root: true,
        });
        // DB -> store 加载主题
        // await dispatch('d2admin/theme/load', null, { root: true })
        // DB -> store 加载页面过渡效果设置
        await dispatch("d2admin/transition/load", null, {
          root: true,
        });
        // DB -> store 持久化数据加载侧边栏折叠状态
        // await dispatch('d2admin/menu/asideCollapseLoad', null, { root: true })
        // DB -> store 持久化数据加载全局尺寸
        await dispatch("d2admin/size/load", null, {
          root: true,
        });
        // end
        resolve();
      });
    },
  },
};
